import Sprite from "../sprite/Sprite";
import Sprites from "../sprite/Sprites";
import { TileBorderCode } from "./TileBorderCode";

export default class TileTemplate {
    constructor() {

        //////////////////////////////////
        // One Border
        //////////////////////////////////

        /**
         * @type {Sprites}
         */
        this.northBorder = null;
        /**
         * @type {Sprite}
         */
        this.eastBorder = null;
        /**
         * @type {Sprite}
         */
        this.southBorder = null;
        /**
         * @type {Sprite}
         */
        this.westBorder = null;

        //////////////////////////////////
        // Two Borders
        //////////////////////////////////

        /**
         * @type {Sprite}
         */
        this.northEastBorder = null;
        /**
         * @type {Sprite}
         */
        this.northSouthBorder = null;
        /**
         * @type {Sprite}
         */
        this.northWestBorder = null;
        /**
         * @type {Sprite}
         */
        this.southEastBorder = null;
        /**
         * @type {Sprite}
         */
        this.eastWestBorder = null;
        /**
         * @type {Sprite}
         */
        this.southWestBorder = null;

        //////////////////////////////////
        // Three Borders
        //////////////////////////////////

        /**
         * @type {Sprite}
         */
        this.northEastSouthBorder = null;
        /**
         * @type {Sprite}
         */
        this.northSouthWestBorder = null;
        /**
         * @type {Sprite}
         */
        this.northEastWestBorder = null;
        /**
         * @type {Sprite}
         */
        this.eastWestSouthBorder = null;

        //////////////////////////////////
        // Four Borders
        //////////////////////////////////

        /**
         * @type {Sprite}
         */
        this.northEastSouthWestBorder = null;

        //////////////////////////////////
        // No Borders
        //////////////////////////////////
        
        /**
         * @type {Sprite}
         */
        this.noBorder = null;
    }

    /**
     * @param {number} borderCode 
     * @returns {Sprite}
     */
    getTileSprite(borderCode) {
        /*
        // Note: The border code is calculated like this:

        const n = this.isBorder(tileCol, tileRow + 1) ? 1 : 0,
            s = this.isBorder(tileCol, tileRow - 1) ? 2 : 0;
            w = this.isBorder(tileCol - 1, tileRow) ? 4 : 0;
            e = this.isBorder(tileCol + 1, tileRow) ? 8 : 0;
        
        this.borderCode = n + s + w + e;
        */

        switch (borderCode) {
            case TileBorderCode.NO_OPEN_BORDERS: // No borders with neighbors
                return this.noBorder;
            case TileBorderCode.NORTH_BORDER_OPEN: // North wall
                return this.northBorder;
            case TileBorderCode.SOUTH_BORDER_OPEN: // South Wall
                return this.southBorder;
            case TileBorderCode.NORTH_SOUTH_OPEN: // North and South
                return this.northSouthBorder;
            case TileBorderCode.WEST_BORDER_OPEN: // West
                return this.westBorder;
            case TileBorderCode.NORTH_WEST_OPEN: // North, West
                return this.northWestBorder;
            case TileBorderCode.SOUTH_WEST_OPEN: // South, West
                return this.southWestBorder;
            case TileBorderCode.NORTH_SOUTH_WEST_OPEN: // North, South, West
                return this.northSouthWestBorder;
            case TileBorderCode.EAST_BORDER_OPEN: // East
                return this.eastBorder;
            case TileBorderCode.NORTH_EAST_OPEN: // North, East
                return this.northEastBorder;
            case TileBorderCode.SOUTH_EAST_OPEN: // South, East
                return this.southEastBorder;
            case TileBorderCode.NORTH_SOUTH_EAST_OPEN: // North, South, East
                return this.northEastSouthBorder;
            case TileBorderCode.WEST_EAST_OPEN: // West, East
                return this.eastWestBorder;
            case TileBorderCode.NORTH_WEST_EAST: // North, West, East
                return this.northEastWestBorder;
            case TileBorderCode.SOUTH_WEST_EAST: // South, West, East
                return this.eastWestSouthBorder;
            case TileBorderCode.ALL_BORDERS_OPEN: // North, South, West, East
                return this.northEastSouthWestBorder;
            default:
                console.log('TileTemplate.getTileSprite() invalid border code: ' + borderCode);
                return this.noBorder;
        }

    }
}